module.exports = __webpack_public_path__ + "static/media/11-male.6935a523.png";